import { i18n } from 'app/utils/i18n';
import { usePermissions } from 'app/utils/hooks/document-permission';
import { useEditorSelector } from 'app/state/contexts/EditorContext';
import { NewDropdown } from 'app/components/ui';
interface EditorModeProps {
  currentMode: 'tagging' | 'editing';
  onModeChange: (mode: 'tagging' | 'editing') => void;
}

export const EditorModePicker = ({ currentMode, onModeChange }: EditorModeProps) => {
  const { pDocument } = useEditorSelector((editor: any) => editor);
  const { documentPermissions } = usePermissions(pDocument?.superId);

  const hasEditPermission = documentPermissions.includes('TAG_EDITOR') || documentPermissions.includes('TAG_ADMIN');
  const hasViewPermission = documentPermissions.includes('TAG_VIEWER');

  if (!hasEditPermission && !hasViewPermission) {
    return null;
  }

  const editingModes = [
    {
      label: i18n('tag.tagging.mode.label'),
      value: 'tagging',
      icon: <i className="fa-regular fa-lg fa-tag" />,
    },
    {
      label: i18n('tag.edit.mode.label'),
      value: 'editing',
      icon: <i className="fa-regular fa-lg fa-pen" />,
    },
  ];

  return <NewDropdown variant="rounded" currentValue={currentMode} options={editingModes} onUpdate={(value) => onModeChange(value as 'tagging' | 'editing')} />;
};
